import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ButtonToolbar, ButtonGroup, Button } from 'react-bootstrap';

export default class DataCollectionGoupAnalysisToolsPlaceHolder extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(datacollectiongroup) {        
        this.props.processDataCollectionGroup(datacollectiongroup);
    }

    render() {
        var _this = this;
        if (this.props.configuration.dataAnalysis.enabled) {
            if (this.props.jobs.datacollectionGroupJobTypes) {
                return <ButtonToolbar>
                    {Object.keys(this.props.jobs.datacollectionGroupJobTypes).map(function (key) {
                        return (
                            <ButtonGroup>
                                <Link disabled target="_blank" to={"/analysis/" + key +  "?datacollectiongroupid=" + _this.props.datacollectiongroup.dataCollectionGroupId}>
                                    <Button onClick={()=>_this.handleClick(_this.props.datacollectiongroup)} bsStyle="primary">{key}</Button>
                                </Link>
                            </ButtonGroup>);
                    })}
                </ButtonToolbar>
            }
        }
        return null;
    }
}






// WEBPACK FOOTER //
// ./src/components/Mx/DataCollectionGroup/SummaryDataCollectionGroup/DataCollectionGoupAnalysisToolsPlaceHolder.js